// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile-container {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: space-between;
}

.student-info {
  width: 40%;
  padding: 25px 30px;
  border: 1px solid #B8B8B8;
  border-radius: 12px;
}

.student-info-header:after {
  margin-bottom: 30px;
  content: '';
  display: block;
  width: 100%;
  height: 1px;
  background-color: #B8B8B8;
}

.student-name {
  margin-bottom: 13px;
  font-size: 26px;
  font-weight: 600;
}

.current-date {
  margin-bottom: 20px;
  font-size: 18px;
  font-weight: 400;
  color: #B7B7B7;
}

.student-info-row {
  margin-bottom: 15px;
}

.student-info-row-name {
  margin-right: 10px;
  font-size: 18px;
  font-weight: 400;
  color: #B8B8B8;
}

.student-info-row-data {
  font-size: 18px;
  font-weight: 400;
  color: #505050;
}

.notifications {
  width: 58%;
  border: 1px solid #B8B8B8;
  border-radius: 12px;
}

.notifications-header {
  padding: 25px 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #B8B8B8;
}

.notifications-title {
  font-size: 20px;
  font-weight: 400;
  color: #394259;
}

.see-all {
  font-size: 18px;
  font-weight: 400;
  color: #B7B7B7;
}

.notification-span{
  padding-right: 10px;
  font-size: 18px;
  font-weight: 400;
  color: #B7B7B7;
}

.notification-block {
  padding: 20px 20px 0px 20px;
}

.notification-block:not(:last-child)::after {
  content: '';
  display: block;
  width: 100%;
  height: 1px;
  background-color: #a2a2a2;
}

.notification-title {
  margin-bottom: 15px;
  font-size: 18px;
  font-weight: 500;
  color: #394259;
}

.notification-text {
  padding-bottom: 20px;
  font-size: 18px;
  font-weight: 400;
}

.no-notifications{
  margin-top: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #434C63;
  font-size: 20px;
}

.pagination-wrapper{
  padding: 0 0 20px 20px;
}

@media screen  and (max-width: 930px) {
  .profile-container {
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: space-between;
  }

  .student-info {
    margin-bottom: 20px;
    width: 100%;
  }

  .notifications {
    width: 100%;
  }
}

@media screen  and (max-width: 520px) {
  .student-name {
    margin-bottom: 10px;
    font-size: 22px;
  }

  .current-date {
    margin-bottom: 15px;
    font-size: 15px;
    font-weight: 400;
    color: #B7B7B7;
  }

  .student-info-header:after {
    margin-bottom: 20px;
  }

  .student-info-row {
    margin-bottom: 10px;
  }

  .student-info-row-name {
    font-size: 15px;
  }

  .student-info-row-data {
    font-size: 15px;
  }

  .notifications-title {
    font-size: 18px;
  }

  .see-all {
    font-size: 16px;
  }

  .notification-title {
    margin-bottom: 12px;
    font-size: 16px;
  }

  .notification-text {
    font-size: 14px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/StudentProfile/style.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,WAAW;EACX,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,cAAc;EACd,WAAW;EACX,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;IACE,sBAAsB;IACtB,iBAAiB;IACjB,8BAA8B;EAChC;;EAEA;IACE,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".profile-container {\n  display: flex;\n  flex-wrap: wrap;\n  flex-direction: row;\n  justify-content: space-between;\n}\n\n.student-info {\n  width: 40%;\n  padding: 25px 30px;\n  border: 1px solid #B8B8B8;\n  border-radius: 12px;\n}\n\n.student-info-header:after {\n  margin-bottom: 30px;\n  content: '';\n  display: block;\n  width: 100%;\n  height: 1px;\n  background-color: #B8B8B8;\n}\n\n.student-name {\n  margin-bottom: 13px;\n  font-size: 26px;\n  font-weight: 600;\n}\n\n.current-date {\n  margin-bottom: 20px;\n  font-size: 18px;\n  font-weight: 400;\n  color: #B7B7B7;\n}\n\n.student-info-row {\n  margin-bottom: 15px;\n}\n\n.student-info-row-name {\n  margin-right: 10px;\n  font-size: 18px;\n  font-weight: 400;\n  color: #B8B8B8;\n}\n\n.student-info-row-data {\n  font-size: 18px;\n  font-weight: 400;\n  color: #505050;\n}\n\n.notifications {\n  width: 58%;\n  border: 1px solid #B8B8B8;\n  border-radius: 12px;\n}\n\n.notifications-header {\n  padding: 25px 20px;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid #B8B8B8;\n}\n\n.notifications-title {\n  font-size: 20px;\n  font-weight: 400;\n  color: #394259;\n}\n\n.see-all {\n  font-size: 18px;\n  font-weight: 400;\n  color: #B7B7B7;\n}\n\n.notification-span{\n  padding-right: 10px;\n  font-size: 18px;\n  font-weight: 400;\n  color: #B7B7B7;\n}\n\n.notification-block {\n  padding: 20px 20px 0px 20px;\n}\n\n.notification-block:not(:last-child)::after {\n  content: '';\n  display: block;\n  width: 100%;\n  height: 1px;\n  background-color: #a2a2a2;\n}\n\n.notification-title {\n  margin-bottom: 15px;\n  font-size: 18px;\n  font-weight: 500;\n  color: #394259;\n}\n\n.notification-text {\n  padding-bottom: 20px;\n  font-size: 18px;\n  font-weight: 400;\n}\n\n.no-notifications{\n  margin-top: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #434C63;\n  font-size: 20px;\n}\n\n.pagination-wrapper{\n  padding: 0 0 20px 20px;\n}\n\n@media screen  and (max-width: 930px) {\n  .profile-container {\n    flex-direction: column;\n    flex-wrap: nowrap;\n    justify-content: space-between;\n  }\n\n  .student-info {\n    margin-bottom: 20px;\n    width: 100%;\n  }\n\n  .notifications {\n    width: 100%;\n  }\n}\n\n@media screen  and (max-width: 520px) {\n  .student-name {\n    margin-bottom: 10px;\n    font-size: 22px;\n  }\n\n  .current-date {\n    margin-bottom: 15px;\n    font-size: 15px;\n    font-weight: 400;\n    color: #B7B7B7;\n  }\n\n  .student-info-header:after {\n    margin-bottom: 20px;\n  }\n\n  .student-info-row {\n    margin-bottom: 10px;\n  }\n\n  .student-info-row-name {\n    font-size: 15px;\n  }\n\n  .student-info-row-data {\n    font-size: 15px;\n  }\n\n  .notifications-title {\n    font-size: 18px;\n  }\n\n  .see-all {\n    font-size: 16px;\n  }\n\n  .notification-title {\n    margin-bottom: 12px;\n    font-size: 16px;\n  }\n\n  .notification-text {\n    font-size: 14px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
